import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';

export const userResolver: ResolveFn<any> = (route, state) => {
  const authService = inject(AuthService);
  return authService.getUserData();
};
